import {useTrackFeature} from '@aboutyou/tracking';
import {useInView} from '@aboutyou/ui-components';
import {useEffect} from 'react';
import {useActivatedCouponState} from '../../../../../features/Coupons/useActivatedCouponState';

export const useTrackCoupons = (productId: number) => {
  const trackFeature = useTrackFeature();
  const {couponPromotionId: activeCouponId} =
    useActivatedCouponState(productId);
  const featureTrackingData = {
    label: activeCouponId,
    name: 'coupon_banner',
  };

  const {inView, ref: trackingRef} = useInView<HTMLDivElement>({
    triggerOnce: true,
    threshold: 0.5,
  });

  /**
   * Using inView with an Effect since we need to run the impression event only
   * once per ADP visit, however we need to trigger the event again when navigating
   * from ADP to ADP or back
   * */
  // eslint-disable-next-line local-rules/prefer-use-inview-effect
  useEffect(() => {
    if (inView) {
      trackFeature({
        ...featureTrackingData,
        eventType: 'impression',
      });
    }
  }, [productId, inView]);

  const featureTrackingClickCallback = () => {
    if (productId) {
      trackFeature({
        ...featureTrackingData,
        eventType: 'click',
      });
    }
  };

  return {
    trackingRef,
    featureTrackingClickCallback,
  };
};
